export const PSD_PREVIEW_LOADERS_TYPES = {
  PROGRESS: 'progress',
  SPINNER: 'spinner'
}
